import { render, staticRenderFns } from "./giftcertificate.vue?vue&type=template&id=0f93f320&scoped=true&"
import script from "./giftcertificate.vue?vue&type=script&lang=js&"
export * from "./giftcertificate.vue?vue&type=script&lang=js&"
import style0 from "./giftcertificate.vue?vue&type=style&index=0&id=0f93f320&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f93f320",
  null
  
)

export default component.exports